import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import { ChevronRight, ArrowUpRight, BookOpen } from "lucide-react";

const CATEGORIES = {
  "": "Tümü",
  danismanlik: "Danışmanlık",
  mevzuat: "Mevzuat",
  yildiz: "Yıldız Standartları",
  secim: "Ekipman Seçimi",
  duzenleme: "Oda Düzenleme",
  trend: "Sektör Trendleri",
};

export default function BlogList() {
  useSeo({
    title: "Blog — Otel Pro Danışmanlık",
    description: "Otel açılış süreçleri, mevzuat, yıldız standartları ve ekipman seçim rehberleri.",
  });
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("");

  useEffect(() => {
    api.get("/blog", { params: cat ? { category: cat } : {} }).then((r) => setPosts(r.data));
  }, [cat]);

  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">Blog</span>
        </div>
      </div>

      <section className="bg-navy text-white py-16">
        <div className="container-site max-w-3xl">
          <div className="flex items-center gap-2 mb-2">
            <BookOpen className="text-gold" size={22} />
            <p className="accent-script text-gold text-xl">Uzman Yazılar</p>
          </div>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold">Otel Pro Blog</h1>
          <p className="text-white/75 mt-3">
            Otel açılış süreçleri, mevzuat, yıldız standartları ve ekipman seçimi — danışmanlarımızın kaleminden.
          </p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site">
          <div className="flex flex-wrap gap-2 mb-8">
            {Object.entries(CATEGORIES).map(([k, v]) => (
              <button
                key={k}
                onClick={() => setCat(k)}
                className={`px-4 py-2 rounded-full text-xs uppercase tracking-wider transition-colors ${
                  cat === k ? "bg-gold text-white" : "bg-softbg text-gray-600 hover:bg-gold/10 hover:text-gold"
                }`}
                data-testid={`blog-filter-${k || "all"}`}
              >
                {v}
              </button>
            ))}
          </div>

          {posts.length === 0 ? (
            <p className="text-center text-gray-500 py-12">Yazı bulunamadı.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} className="card-premium overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden bg-softbg">
                      <img src={p.cover_image} alt={p.title_tr} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                    </div>
                  )}
                  <div className="p-5">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-gold font-medium mb-2">
                      {CATEGORIES[p.category] || "Danışmanlık"}
                    </p>
                    <h3 className="heading-serif text-lg font-semibold text-navy group-hover:text-gold transition-colors leading-snug mb-2">
                      {p.title_tr}
                    </h3>
                    <p className="text-xs text-gray-600 line-clamp-2">{p.excerpt}</p>
                    <span className="inline-flex items-center gap-1 text-gold text-xs mt-3">
                      Devamını Oku <ArrowUpRight size={12} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
